import ForgotPage from './ForgotPage';
export default ForgotPage;